module.exports = __webpack_public_path__ + "img/12217_15.bf24df54.png";